import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodefactorComponent } from './simple-icons-codefactor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodefactorComponent ],
    exports:      [ SimpleIconsCodefactorComponent ],
    bootstrap:    []
})
export class SimpleIconsCodefactorModule {}
